<div class="gray-200 pt-10">
  <ul class="ohio-breadcrumbs">
    @for (breadcrumb of breadcrumbs(); track breadcrumb) {
      @for (breadcrumblabel  of breadcrumb?.label; track breadcrumblabel ) {
        <li class="ohio-breadcrumbs-item">
          <a [routerLink]="[breadcrumblabel?.url]">{{breadcrumblabel?.label}}</a>
        </li>
      }
    }
  </ul>
</div>
